import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useScrollTo } from "@/hooks/useScrollTo";
import { InteractionEnum } from "@/types";
import { FarbweltLogo } from "@/components";
import { useFarbwelt } from "@/hooks";
import { Box } from "@gemini/core";
export const farbweltBannerTestId = "cdp-farbwelt-banner";
export const FarbweltBanner = ({ isDesktop }) => {
    const { bgColor, logo, isFarbweltActive, providerName, textColor } = useFarbwelt();
    const borderStyle = {
        borderColor: "color.border.disabled",
        borderWidth: "borderWidth.1",
    };
    const hasBanner = isFarbweltActive && (bgColor || logo);
    const scrollToProvider = useScrollTo(InteractionEnum.SCROLL_TO_PROPERTY_PROVIDER);
    if (!hasBanner)
        return null;
    return isDesktop ? (_jsxs(Box, { unsafe_style: {
            backgroundColor: bgColor,
        }, borderColor: "color.border.light.default", height: "sizing.48", width: "100%", borderTopLeftRadius: "radius.16", borderTopRightRadius: "radius.16", paddingLeft: "spacing.24", paddingRight: "spacing.16", paddingVertical: "spacing.8", display: {
            "breakpoint.base": "none",
            "breakpoint.lg": "flex",
        }, alignItems: "center", testId: `${farbweltBannerTestId}-desktop`, unsafe_className: "FarbweltBannerDesktop", borderWidth: "borderWidth.1", borderStyle: "solid", borderBottomWidth: "borderWidth.none", onClick: scrollToProvider, cursor: "pointer", children: [_jsx(FarbweltLogo, { testId: `${farbweltBannerTestId}-logo` }), !logo && (_jsx(Box, { as: "span", typography: "typography.body.16.regular", color: textColor, cursor: "pointer", children: providerName }))] })) : (_jsxs(Box, Object.assign({ unsafe_style: {
            backgroundColor: bgColor,
        }, width: "100%", height: "sizing.64", marginTop: "-spacing.16", paddingLeft: "spacing.24", paddingRight: "spacing.16", paddingTop: "spacing.8", paddingBottom: "spacing.24", display: {
            "breakpoint.base": "flex",
            "breakpoint.lg": "none",
        }, position: "relative", alignItems: "center", testId: `${farbweltBannerTestId}-mobile`, unsafe_className: "FarbweltBannerMobile", borderTopLeftRadius: "radius.16", borderTopRightRadius: "radius.16" }, borderStyle, { borderLeftWidth: "borderWidth.none", borderRightWidth: "borderWidth.none", onClick: scrollToProvider, cursor: "pointer", children: [_jsx(FarbweltLogo, { testId: `${farbweltBannerTestId}-logo` }), !logo && (_jsx(Box, { as: "span", typography: "typography.body.16.regular", color: textColor, cursor: "pointer", unsafe_style: {
                    display: "-webkit-box",
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: "vertical",
                    whiteSpace: "pre-line",
                    overflow: "hidden",
                }, children: providerName }))] })));
};
